<template>
  <div class="">
    <div class="form-question v-pa-md bg-msg v-mb-md">
      <div class="msg-info-question">
        <div class="msg-info-container">
          <div class="msg-info-header">
            <span class="msg-info-questioner">{{ question.spSpeakerName }}</span>
            <span class="msg-info-op text-ask">问</span>
            <span class="msg-info-answerer">{{ question.spGuest }}</span>
            <span class="msg-info-date v-mx-sm">{{ question.spDatetime }}</span>
            <a-tag class="v-mr-md tag-tiny" color="#333" v-if="question.spState === 2">已封禁</a-tag>
          </div>
          <div class="msg-info-content content-ask">{{ question.spContent }}</div>
        </div>
      </div>
      <template v-if="question.replyList">
        <div class="msg-info-replies" v-for="reply in question.replyList" :key="reply.reId" v-show="reply.astate === 1 || reply.reId === data.reId">
          <div class="msg-info-container" :class="{ active: reply.reId === data.reId }">
            <div class="msg-info-container_wrapper">
              <div class="msg-info-header">
                <span class="msg-info-answerer">{{ reply.gname }}</span>
                <span class="msg-info-op text-reply">答</span>
                <span class="msg-info-date v-mr-md">{{ reply.datetime }}</span>
                <a-tag class="v-mr-md tag-tiny" color="#f50" v-if="reply.astate === 0">待审核</a-tag>
                <a-tag class="v-mr-md tag-tiny" color="#333" v-else-if="reply.astate === 2">已封禁</a-tag>
              </div>
              <div class="msg-info-content content-reply" v-html="$utils.convertToHtml(reply.acontent)"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <a-form-model ref="ruleForm" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
      <a-form-model-item>
        <span slot="label"><b class="text-red">*</b> 回答嘉宾</span>
        <a-select placeholder="选择嘉宾" allowClear v-model="form.gid" ref="gname" style="width: 70%" @change="onGuestChange">
          <a-select-option v-for="item in guests" :key="item.gid" :value="item.gId">
            {{ item.gName }}<template v-if="item.gPost">（{{ item.gPost }}）</template>
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <span slot="label"><b class="text-red">*</b> 回复时间</span>
        <a-date-picker v-model="form.datetime" ref="datetime" show-time placeholder="选择时间" @change="onDateChange" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
      </a-form-model-item>
      <a-form-model-item>
        <span slot="label"><b class="text-red">*</b> 回复内容</span>
        <a-textarea v-model="form.acontent" ref="acontent" placeholder="回答内容" :rows="6" />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import audit from '@/mixins/audit'
import { getRoadshowGuestByPage } from '@/api/roadshow'
import { updateReply } from '@/api/interact'
const form = {
  gname: '',
  datetime: undefined,
  acontent: '',
}
export default {
  name: 'ReplyForm',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    question: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [audit],
  data() {
    return {
      form,
    }
  },
  watch: {
    data() {
      console.log('ReplyForm', this.data)
      this.form = { ...this.data }
    },
    form: {
      handler(obj) {
        console.log('ReplyForm watch')
        if (obj.reId) {
          if (this.question.replyList) {
            let reply = this.question.replyList.find((r) => r.reId === obj.reId)
            if (reply) {
              reply.acontent = obj.acontent
              reply.datetime = obj.datetime
              reply.gid = obj.gid
              if (obj.gid) {
                let guest = this.guests.find((g) => g.gId === obj.gid)
                reply.gname = (guest && guest.gName) || reply.gname
              }
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    loadGuests(rsId) {
      let params = {
        pageSize: -1,
        rsId,
        gType: 0,
      }
      getRoadshowGuestByPage(params).then(({ data }) => {
        if (data.success) {
          this.guests = data.result.records
        }
      })
    },
    handleSubmit(passed) {
      let vm = this
      return new Promise((resolve, reject) => {
        let params = { ...vm.form }
        if (params.gid) {
          let guest = vm.guests.find((g) => g.gId === params.gid)
          params.gname = (guest && guest.gName) || ''
        } else {
          params.gname = ''
        }
        params.astate = passed ? 1 : params.astate
        if (params.gname.trim() === '') {
          this.$message.warning('请选择回答嘉宾')
          this.$refs.gname.focus()
          reject('请选择回答嘉宾')
          return
        }
        if (!params.datetime) {
          this.$message.warning('请选择回复时间')
          this.$refs.datetime.focus()
          reject('请选择回复时间')
          return
        }
        if (params.acontent.trim() === '') {
          this.$message.warning('请输入回复内容')
          this.$refs.acontent.focus()
          reject('请输入回复内容')
          return
        }
        updateReply(params)
          .then(({ data }) => {
            if (data.success) {
              resolve(data)
            } else {
              reject(data.msg)
            }
          })
          .catch(() => {
            reject('保存失败')
          })
      })
    },
    onDateChange(date, dateString) {
      console.log(date, dateString)
    },
    onGuestChange(value, option) {
      console.log(value, option)
    },
  },
  created() {
    this.form = { form, ...this.data }
    // this.loadGuests(this.form.rsId)
  },
}
</script>
